export enum SubscriptionPlan {
  'Free' = 'free',
  'Paid' = 'paid',
}

export enum SubscriptionCycle {
  'Monthly' = 'monthly',
  'Yearly' = 'yearly',
}

export enum SubscriptionStatus {
  'Active' = 'active',
  'Suspended' = 'suspended',
  'Cancelled' = 'cancelled',
  'Expired' = 'expired',
}
